const RollbarTest = () => {
	throw "tkit-app rollbar-test " + new Date();

	return <div>Can't see this</div>;
};

export default RollbarTest;
